import React, { Fragment } from "react";
import { Input, Label } from "reactstrap";
import { VARIATION_SWITCH_LIST_1 } from "../../../../Data/FormWidgets";
import { LI, P } from "../../../../AbstractElements";

export const VariationOfSwitcheOne = () => {
  return (
    <>
      {VARIATION_SWITCH_LIST_1.map(({ id, inputClass, text,offData,onData }, index) => (
        <Fragment key={index}>
          <LI className="tg-list-item">
            <Input className={`tgl ${inputClass}`} id={id} type="checkbox" />
            <Label className="tgl-btn" data-tg-off={offData} data-tg-on={onData}  htmlFor={id}></Label>
          </LI>
          <LI>
            <P>{text}</P>
          </LI>
        </Fragment>
      ))}
    </>
  );
};
